import { createStyles } from "@material-ui/core";

export type DamageCostsClassKey = "pageTitle";

export const DamageCostsStyleRules = createStyles({
  pageTitle: {
    marginTop: "40px",
  },
});
